import Vue from 'vue'
import Router from 'vue-router'
import Clusters from '@/components/clusters/Clusters'
import ClusterDetails from '@/components/clusters/ClusterDetails'
import Playlists from '@/components/playlists/Playlists'
import PlaylistDetails from '@/components/playlists/PlaylistDetails'
import PlaylistAddEdit from '@/components/playlists/PlaylistAddEdit'
import Devices from '@/components/devices/Devices'
import Menus from '@/components/menu/Menus'
import MenuDetails from '@/components/menu/MenuDetails'
import Login from '@/components/login/Login'
import Analytics from '@/components/analytics/Analytics'
import PlaylistsStorage from '@/components/storage/playlists/PlaylistsStorage'
import MenusStorage from '@/components/storage/menus/MenusStorage'
import OffersStorage from '@/components/storage/offers/OffersStorage'
import PowerDevices from '@/components/powerdevices/PowerDevices'
import CustomerSatisfaction from '@/components/customersatisfaction/CustomerSatisfaction'
import Documents from '@/components/documents/Documents'
import Questionnaires from '../components/questionnaires/Questionnaires.vue'
import AppMenu from '../components/appmenu/AppMenu.vue'
import AppMenuPdfs from '../components/appmenu/AppMenuPdfs.vue'
import QuestionnaireAnalytics from '../components/questionnaireanalytics/QuestionnaireAnalytics.vue'
import Tickets from '../components/tickets/Tickets.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/playlists',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/clusters',
      name: 'Clusters',
      component: Clusters,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/clusters/:id',
      name: 'ClusterDetails',
      component: ClusterDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlists',
      name: 'Playlists',
      component: Playlists,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlists/add',
      name: 'PlaylistAddEdit',
      component: PlaylistAddEdit,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlists/:id',
      name: 'PlaylistDetails',
      component: PlaylistDetails,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlists/:id/edit',
      name: 'PlaylistEdit',
      component: PlaylistAddEdit,
      props: { editEnabled: true },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/devices',
      name: 'Devices',
      component: Devices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/powerdevices',
      name: 'PowerDevices',
      component: PowerDevices,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menus',
      name: 'Menus',
      component: Menus,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menus/:id',
      name: 'MenuDetails',
      component: MenuDetails,
      props: { isSpecialOffer: false },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/offers/:id',
      name: 'SpecialOfferDetails',
      component: MenuDetails,
      props: { isSpecialOffer: true },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/offers',
      name: 'SpecialOffers',
      component: Menus,
      props: { specialOffersEnabled: true },
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/documents',
      name: 'Documents',
      component: Documents,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/customersatisfaction',
      name: 'CustomerSatisfaction',
      component: CustomerSatisfaction,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/analytics',
      name: 'Analytics',
      component: Analytics,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/playlistsstorage',
      name: 'PlaylistsStorage',
      component: PlaylistsStorage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/menusstorage',
      name: 'MenusStorage',
      component: MenusStorage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/specialoffersstorage',
      name: 'OffersStorage',
      component: OffersStorage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/questionnaires',
      name: 'Questionnaires',
      component: Questionnaires,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/questionnaireanalytics',
      name: 'QuestionnaireAnalytics',
      component: QuestionnaireAnalytics,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/appmenu',
      name: 'AppMenu',
      component: AppMenu,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/appmenupdfs',
      name: 'AppMenuPdfs',
      component: AppMenuPdfs,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tickets',
      name: 'Tickets',
      component: Tickets,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '*',
      redirect: '/playlists'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js